/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { EnvService } from "namirasoft-core";
import { MessageMetaTable } from "./MessageMetaTable";
import { NSBaseMetaDatabase } from "namirasoft-site";
import { NamirasoftMessageServer } from "../NamirasoftMessageServer";
import { TokenManager } from "namirasoft-account";

export class NamirasoftMessageMetaDatabase extends NSBaseMetaDatabase<NamirasoftMessageServer>
{
    private manager?: TokenManager;
    private onError?: (error: Error) => void;
    public override tables: {
        message: MessageMetaTable,
    };
    constructor(manager?: TokenManager, onError?: (error: Error) => void)
    {
        super({ id: "prd-17241f2d8d264b01", name: "Namirasoft Message", headline: "Message Event Tracking", description: "A service that provides a comprehensive record of all events related to the messages you have sent via various channels.", logo: "https://static.namirasoft.com/image/namirasoft/message/logo/base.png", link: "https://message.namirasoft.com" });
        this.manager = manager;
        this.onError = onError;
        this.tables = {
            message: new MessageMetaTable(this),
        };
    }
    override getServer(): NamirasoftMessageServer
    {
        if (!this.manager || !this.onError)
            throw new Error("Arguments of NamirasoftMessageMetaDatabase (manager, onError) are required for server operations.")
        let NAME = NSBaseMetaDatabase.getServerBaseURL(this.product.name);
        let BASE_URL = new EnvService(NAME, true).getString();
        return new NamirasoftMessageServer(BASE_URL, this.manager, this.onError);
    }
};